// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/** Lien : la chaine. Source `link.svg`. */
export const IconLink = createCustomIcon(
  'IconLink',
  '0 0 209.39 209.42',
  <>
    <polygon
      fill="currentColor"
      points="174.2 75.74 133.71 35.16 96.83 71.95 79.28 54.43 133.67 0 209.39 75.72 154.96 130.1 137.43 112.56 174.2 75.74"
    />
    <polygon
      fill="currentColor"
      points="112.48 137.49 130.08 154.98 75.69 209.42 0 133.76 54.25 79.38 71.94 96.83 35.14 133.73 75.67 174.26 112.48 137.49"
    />
    <rect
      fill="currentColor"
      x="64.72"
      y="92.22"
      width="79.92"
      height="24.99"
      transform="translate(-43.38 104.69) rotate(-45)"
    />
  </>,
);
